// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanTag_base--1swEJ","base__small":"ClanTag_base__small--3byLT","baseSmall":"ClanTag_base__small--3byLT","base__medium":"ClanTag_base__medium--1SN94","baseMedium":"ClanTag_base__medium--1SN94","emblem":"ClanTag_emblem--AKbF4"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/ClanTag/ClanTag.css
// module id = 1748
// module chunks = 16